import React, { useCallback, useEffect } from 'react'
import { useNavigate } from 'react-router-dom'

import { HOME_IMAGE } from 'constant'
import { useLayout } from 'contexts/LayoutProvider'
import { AdaptiveImage } from 'features/common/components/AdaptiveImage'
import { Activity, Location, SearchScope } from 'features/common/types'
import SearchForm from 'features/home/SearchForm'

const HomePage = () => {
  const { setShowHeader } = useLayout()
  const navigate = useNavigate()

  useEffect(() => {
    setShowHeader(true)
  }, [setShowHeader])

  const onSearch = useCallback(
    (
      location: Location | undefined,
      scope: SearchScope | undefined,
      polygons: [number, number][][] | undefined,
      activities: Activity[],
      selectedAll: boolean,
    ) => {
      if ((location || scope || polygons) && activities.length > 0) {
        const activityIds = activities.map(item => item._id).join(',')
        const activityParam = selectedAll ? '' : `&activityIds=${activityIds}`
        let locationParam = ''
        if (location) {
          locationParam = `locationId=${location?._id}`
        } else if (scope) {
          locationParam = `pin_lat=${scope?.center?.lat || ''}&pin_lng=${scope?.center?.lng || ''}&radius=${scope?.distance}`
        } else if (polygons) {
          locationParam = `polygons=${JSON.stringify(polygons)}`
        }
        navigate(`/search?${locationParam}${activityParam}`)
      }
    },
    [navigate],
  )

  return (
    <div className="flex flex-col h-full">
      <div className="flex flex-col p-[30px] space-y-10 pt-10 bg-blue-100 rounded-3xl z-10">
        <div className="flex flex-col gap-2 justify-center">
          <p className="font-semibold text-2xl text-blue-700">{'Watersports'}</p>
          <p className="font-normal text-2xl">{'All activities. All providers.'}</p>
          <p className="font-normal text-2xl">{'Best prices.'}</p>
        </div>
        <SearchForm onSearch={onSearch} />
      </div>
      <div className="flex-1 relative overflow-hidden -mt-5">
        <AdaptiveImage file={HOME_IMAGE} className="absolute inset-0 w-full h-full object-cover" />
      </div>
    </div>
  )
}

export default HomePage
